import { gql } from '@apollo/client';
import TENANT_MANUFACTURER from 'api/fragments/TENANT_MANUFACTURER';
const UPDATE_TENANT_MANUFACTURER = gql `
  ${TENANT_MANUFACTURER}
  mutation UpdateTenantManufacturer(
    $manufacturerId: ID!
    $fullName: String
    $shortName: String
    $addressCity: String
    $addressPostalCode: String
    $addressStreet: String
    $addressNumber: String
    $vatNumber: String
    $emailAddress: String
    $contactPhone: String
    $employeesCount: Int
    $countryOfOrigin: String
  ) {
    updateManufacturer(
      manufacturerId: $manufacturerId
      fullName: $fullName
      shortName: $shortName
      addressCity: $addressCity
      addressPostalCode: $addressPostalCode
      addressStreet: $addressStreet
      addressNumber: $addressNumber
      vatNumber: $vatNumber
      emailAddress: $emailAddress
      contactPhone: $contactPhone
      employeesCount: $employeesCount
      countryOfOrigin: $countryOfOrigin
    ) {
      manufacturer {
        ...TenantManufacturerFragment
      }
    }
  }
`;
export default UPDATE_TENANT_MANUFACTURER;
